/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 is 30% of what number? 18 ÷ (30 ÷ 100) = 60.`)
};

const es_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿18 es el 30% de qué número? 18 ÷ (30 ÷ 100) = 60.`)
};

const de_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 sind 30% von welcher Zahl? 18 ÷ (30 ÷ 100) = 60.`)
};

const nl_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 is 30% van welk getal? 18 ÷ (30 ÷ 100) = 60.`)
};

const fr_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 représente 30 % de quel nombre ? 18 ÷ (30 ÷ 100) = 60.`)
};

const it_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 è il 30% di quale numero? 18 ÷ (30 ÷ 100) = 60.`)
};

const pt_br2_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 é 30% de que número? 18 ÷ (30 ÷ 100) = 60.`)
};

const pt_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 é 30% de que número? 18 ÷ (30 ÷ 100) = 60.`)
};

const ja_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18はある数の30%です。その数は？ 18 ÷ (30 ÷ 100) = 60。`)
};

const zh_pct_hub_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 是哪个数的 30%？18 ÷ (30 ÷ 100) = 60。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_ex3", locale)
	if (locale === "en") return en_pct_hub_ex3(inputs)
	if (locale === "es") return es_pct_hub_ex3(inputs)
	if (locale === "de") return de_pct_hub_ex3(inputs)
	if (locale === "nl") return nl_pct_hub_ex3(inputs)
	if (locale === "fr") return fr_pct_hub_ex3(inputs)
	if (locale === "it") return it_pct_hub_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_ex3(inputs)
	if (locale === "pt") return pt_pct_hub_ex3(inputs)
	if (locale === "ja") return ja_pct_hub_ex3(inputs)
	return zh_pct_hub_ex3(inputs)
};